import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-new-desk-breadcrumb-card',
  templateUrl: './turns-new-desk-breadcrumb-card.component.html',
  styleUrls: ['./turns-new-desk-breadcrumb-card.component.scss']
})
export class TurnsNewDeskBreadcrumbCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
